import { useState, useEffect } from "react"
import MDBox from "components/MDBox"
import { Card } from "@mui/material"
import MDTypography from "components/MDTypography"
import ManageMemo from "../../../manage/memo/"
import Button from "@mui/material/Button"

interface MemoProps {
  id: string
  body: string
  stop_mail: number
}

const Memo: React.FC<MemoProps> = ({ id, body, stop_mail }) => {
  const [showUpdateMemoButton, setShowUpdateMemoButton] = useState<boolean>(false)
  const [memoUpdate, setMemoUpdate] = useState<boolean>(false)
  const [showBody, setShowBody] = useState<string>(body)
  const [stopMail, setStopMail] = useState<number>(0)

  useEffect(() => {
    const auth = localStorage.getItem("account_type")
    if (auth == "estate") {
      setShowUpdateMemoButton(true)
    }
  }, [])

  const handleMemo = () => {
    setMemoUpdate(true)
  }

  const handleClose = (body: string, stop_mail: number | null) => {
    setMemoUpdate(false)
    if (body != null) {
      setShowBody(body)
    }
    if (stop_mail != null && stop_mail != -1) {
      setStopMail(stop_mail)
    }
  }
  useEffect(() => {
    setShowBody(body)
  }, [body])
  useEffect(() => {
    setStopMail(stop_mail)
  }, [stop_mail])

  return (
    <>
      {memoUpdate && <ManageMemo id={id} body={showBody} stop_mail={stopMail} onClose={handleClose} />}
      {showBody !== "" || stopMail === 1 ? (
        <Card sx={{ height: "100%", padding: "20px" }}>
          <MDBox display="flex" flexWrap="wrap">
            <MDTypography variant="h4" fontWeight="medium" sx={{ marginRight: "20px", flexShrink: 1 }}>
              Memo
            </MDTypography>
            {stopMail == 1 && (
              <MDBox
                sx={{
                  marginRight: "100px",
                  color: "#ff0000",
                  width: "100px",
                  maxWidth: "100px",
                  minWidth: "100px",
                  flexShrink: 1
                }}
              >
                通知OFF
              </MDBox>
            )}
            {showUpdateMemoButton && (
              <MDBox sx={{ position: "absolute", top: "20px", right: "20px" }}>
                <Button variant="contained" color="primary" size="small" sx={{ color: "#FFF" }} onClick={handleMemo}>
                  編集
                </Button>
              </MDBox>
            )}
          </MDBox>
          {showBody !== "" && (
            <MDBox>
              <MDTypography
                variant="body2"
                color="text"
                fontWeight="regular"
                sx={{ fontSize: "14px" }}
                dangerouslySetInnerHTML={{ __html: showBody.replace(/\n/g, "<br />") }} // ← 改行対応
              />
            </MDBox>
          )}
        </Card>
      ) : (
        <>
          {showUpdateMemoButton && (
            <Card sx={{ height: "100%", padding: "20px" }}>
              <MDBox display="flex">
                <MDTypography variant="h4" fontWeight="medium">
                  Memo
                </MDTypography>
                <MDBox sx={{ position: "absolute", top: "20px", right: "20px" }}>
                  <Button variant="contained" color="primary" size="small" sx={{ color: "#FFF" }} onClick={handleMemo}>
                    編集
                  </Button>
                </MDBox>
              </MDBox>
            </Card>
          )}
        </>
      )}
    </>
  )
}

export default Memo
